import { FC, useEffect, useMemo, useState } from 'react'

import { Layout } from 'components/layout'
import { HelpAnimation } from 'components/radio/help-animation'
import { videoHelpData } from 'components/radio/helpers'
import { Video } from './video'
import { TVImage } from './tv-image'
import { DebugLine, DebugValue, TVContainer, View } from './styled'
import { usePlayerContext } from 'context/player-context'

const START_OFFSET = 10
const VIDEO_LENGTH = 10
const VIDEO_SPACING = 10

// todo GET video list from backend?
const videoURLs: Array<{ url: string; alias: string }> = [
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video1.mp4',
    alias: 'video title 1',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video2.mp4',
    alias: 'video title 2',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video3.mp4',
    alias: 'video title 3',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video4.mp4',
    alias: 'video title 4',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video5.mp4',
    alias: 'video title 5',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video6.mp4',
    alias: 'video title 6',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video7.mp4',
    alias: 'video title 7',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video8.mp4',
    alias: 'video title 8',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video9.mp4',
    alias: 'video title 9',
  },
  {
    url: 'https://docs.rferl.org/Infographics/2023/2023_01/2023_01_Anniversary/video/video10.mp4',
    alias: 'video title 10',
  },
]

const mapCoordsToYear = (value: number) => {
  const v = Math.floor((value - START_OFFSET) / (VIDEO_LENGTH + VIDEO_SPACING))

  if (
    value >= START_OFFSET &&
    (value - START_OFFSET) % (VIDEO_LENGTH + VIDEO_SPACING) < VIDEO_LENGTH &&
    v <= videoURLs.length - 1
  ) {
    return videoURLs[v]
  }

  return { url: '', alias: '' }
}

export const TV: FC = () => {
  const [value, setValue] = useState(0)
  const {
    permissionsGranted,
    videoProgress,
    isVideoHelpDone,
    makeVideoHelpDone,
  } = usePlayerContext()
  const roundedValue = useMemo(() => Math.round(value), [value])
  const videoFile = mapCoordsToYear(value)

  const handleScroll = (delta: number) => {
    videoProgress.set(Math.max(videoProgress.get() + delta, 0))
  }

  const scrollManually = (direction: number) => () =>
    handleScroll(10 * direction)

  useEffect(() => {
    const unsubscribe = videoProgress.onChange(setValue)
    return () => unsubscribe()
  }, [])

  return (
    <>
      <View>
        <TVContainer>
          <Video value={roundedValue} videoFileUrl={videoFile.url || ''} />
          <TVImage
            progress={videoProgress}
            onScroll={handleScroll}
            onMinus={scrollManually(-1)}
            onPlus={scrollManually(1)}
          />

          <table style={{ position: 'absolute', top: '100%', display: 'none' }}>
            <tbody>
              <DebugLine as="tr">
                <td style={{ width: '10em' }}>Currently Playing:</td>
                <td style={{ width: 'auto' }}>
                  <DebugValue>{videoFile.alias || '–'}</DebugValue>
                </td>
              </DebugLine>
              <DebugLine as="tr">
                <td>Current value:</td>
                <td>
                  <DebugValue>{roundedValue}</DebugValue>
                </td>
              </DebugLine>
            </tbody>
          </table>

          {permissionsGranted && !isVideoHelpDone && (
            <HelpAnimation
              isHelpDone={isVideoHelpDone}
              makeHelpDone={makeVideoHelpDone}
              helpData={videoHelpData}
            />
          )}
        </TVContainer>
      </View>
      <Layout />
    </>
  )
}
